// Infinite scrolling for Blazor lists (e.g. Mediathek tile view, LibraryList.razor):
// calls the [JSInvokable] LoadMoreAsync on the .NET side whenever the sentinel element
// placed after the last rendered item scrolls into view.

type DotNetObjectReference = {
	invokeMethodAsync: (methodName: string, ...args: unknown[]) => Promise<unknown>;
};

const observers = new Map<Element, IntersectionObserver>();

function disconnect(sentinel: Element) {
	observers.get(sentinel)?.disconnect();
	observers.delete(sentinel);
}

function observe(sentinel: Element, dotNetRef: DotNetObjectReference) {
	disconnect(sentinel);

	const observer = new IntersectionObserver(
		(entries) => {
			if (entries.some((e) => e.isIntersecting)) {
				dotNetRef.invokeMethodAsync('LoadMoreAsync');
			}
		},
		{ rootMargin: '400px 0px' }
	);

	observer.observe(sentinel);
	observers.set(sentinel, observer);
}

export const infiniteScroll = { observe, disconnect };
